import qs from 'qs';
import { pick, pickBy } from 'lodash';

const GetFormatted = {
  queryWithType: (searchQuery, type) => `?query=${searchQuery}&search_type=${type}`,
  query: (searchQuery) => `?query=${searchQuery}`,
  haveSearch: (location, query) => `${location.pathname}?${(location.search = query)}`,
  clearQuery: (location, query) => `${location.pathname}?${(location.search = query)}`,
};

export const searchRequest = (searchQuery, query, location, history, queryString, additionalPickDateFilters = []) => {
  const pickDateFilers = qs.stringify(pick(queryString, ['period_code', 'date_from', 'date_to', 'delay', 'service', 'services', ...additionalPickDateFilters]));
  if (searchQuery === '') {
    return history.push(GetFormatted.clearQuery(location, pickDateFilers));
  }

  if (location.search === '') {
    return history.push(`${location.pathname}${query}`);
  }

  if (location.search || location.search.includes('query')) {
    return history.push(GetFormatted.haveSearch(location, qs.stringify({ ...pickBy(qs.parse(pickDateFilers)), ...qs.parse(query.slice(1)) })));
  }
};

export const detectQueryValue = (haveOptions, withSelect, searchQuery, type) => {
  let query;

  if (haveOptions && withSelect) {
    query = GetFormatted.queryWithType(searchQuery, type);
  } else {
    query = GetFormatted.query(searchQuery);
  }

  return query;
};
